var __TEMP__ = require('./_baseIsMatch.js');var baseIsMatch = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getMatchData.js');var getMatchData = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_matchesStrictComparable.js');var matchesStrictComparable = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseMatches;
